import React, { Component, Fragment } from 'react';
import PageTitle from "../../PageTitle";
import {DatePicker, TextField} from "office-ui-fabric-react";
import ApiService from "../../ApiService";
import { AdminAssignmentAnalyticsSeedControls } from "../../AdminAssignmentAnalyticsSeedControls";
import moment from "moment";
import School from "../../../models/School";
import LoadingPage from "../../LoadingPage";

interface SeedAssignmentsPageProps {
    apiService: ApiService
    tenantId: string;
    schoolCode: string;
}

interface SeedAssignmentsPageState {
    school?: School;
    academicYear: number;
    startDate: Date;
    endDate: Date;
}

export class SeedAssignmentsPage extends Component<SeedAssignmentsPageProps, SeedAssignmentsPageState> {
    static displayName = SeedAssignmentsPage.name;

    constructor(props: SeedAssignmentsPageProps) {
        super(props);
        
        this.state = {
            school: undefined,
            academicYear: 2025,
            startDate: moment().toDate(),
            endDate: moment().add(3,'months').toDate(), 
        }
    }

    async componentDidMount() {
        
        const school = await this.props.apiService.getSchoolAdmin(this.props.tenantId, this.props.schoolCode);

        this.setState({
            school: school
        });
    }
    

    render() {
        
        if(this.state.school === undefined)
        {
            return <LoadingPage/>;
        }
        
        return (
            <Fragment>
                <PageTitle title={"Seed Admin Assignment Analytics Data"}/>

                <div className="card">
                    <div className="card__header">
                        <span className={"card__title"}>Seed Assignment Analytics Data</span>
                    </div>
                    <div className="card__content flex-column">
                        
                        <TextField className="card__input"
                                   label="Academic Year"
                                   type="number"
                                   value={this.state.academicYear.toString()}
                                   onChange={(_, value) => {
                                       this.setState({
                                           academicYear: Number.parseInt(value!)
                                       });
                                   }}/>
                        
                        <DatePicker
                            className={"card__input"}
                            label={"From"}
                            value={this.state.startDate}
                            onSelectDate={(value) => {
                                this.setState({
                                    startDate: value! as any
                                });
                            }}
                            placeholder="Select a date..."
                            ariaLabel="Select a date"
                        />

                        <DatePicker
                            className={"card__input"}
                            label={"To"}
                            value={this.state.endDate}
                            onSelectDate={(value) => {
                                this.setState({
                                    endDate: value! as any
                                });
                            }}
                            placeholder="Select a date..."
                            ariaLabel="Select a date"
                        />
                        
                        <AdminAssignmentAnalyticsSeedControls
                            tenantName={this.state.school?.tenantName!}
                            schoolCode={this.props.schoolCode}
                            apiService={this.props.apiService}
                            academicYear={this.state.academicYear}
                            startDate={this.state.startDate.toString()}
                            endDate={this.state.endDate.toString()}
                        />
                    </div>
                </div>
            </Fragment>
        );
    }
}

